module.exports = __webpack_public_path__ + "static/media/defaultProfile.5d3bde1b.svg";